import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Row,
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFile,
  faFolder,
  faFolderPlus,
  faPlus,
  faTrash,
  faTrashAlt,
  faHardDrive,
} from '@fortawesome/free-solid-svg-icons'

import Search from 'views/pages/Search'
import { fetchMyDocuments, deleteMyDocument } from 'store/Library/actions'
import ViewSubmissionModal from 'views/pages/MaintenanceLog/ViewSubmissionModal'

import "../styles/styles.css"

const MyDocuments = (props) => {
  const [searchMyDocs, setSearchMyDocs] = useState('')
  const [currentFolderId, setCurrentFolderId] = useState(null)
  const [folderPath, setFolderPath] = useState([])
  const [showViewSubmissionModal, setShowViewSubmissionModal] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [selectedSubmissionId, setSelectedSubmissionId] = useState(null)
  const [selectedUserId, setSelectedUserId] = useState(null)

  const language = props.language || {}
  const dispatch = useDispatch()
  const {
    user: { access },
  } = useSelector((store) => store.auth)

  useEffect(() => {
    dispatch(fetchMyDocuments())
  }, [dispatch])

  const handleSearchChange = (event) => {
    setSearchMyDocs(event.target.value)
  }

  const handleFolderClick = (folder) => {
    setCurrentFolderId(folder.id)
    // dispatch({ type: SET_PARENT_ID, parentId: folder.id })

    setFolderPath([...folderPath, folder])
    // No need to fetch - we already have all myFiles data locally
  }

  const handleSubmissionClick = (item) => {
    try {
      // Parse the form_submission_data JSON string
      const submissionData = JSON.parse(item.form_submission_data)
      setSelectedSubmissionId(submissionData.submissionId)
      setSelectedUserId(submissionData.userId)
      setActiveTab(0)
      setShowViewSubmissionModal(true)
    } catch (error) {
      console.error('Error parsing form submission data:', error)
      alert('Error opening form submission. Please try again.')
    }
  }

  // Filter items based on current folder and search
  const getFilteredItems = () => {
    if (!props.library.myFiles) return []

    let items = props.library.myFiles

    // Filter by current folder if we're inside one
    if (currentFolderId) {
      items = items.filter((item) => item.parent_id === currentFolderId)
    } else {
      // Show root level items (items without parent_id or parent_id is null)
      items = items.filter((item) => !item.parent_id || item.parent_id === null)
    }

    // Apply search filter
    if (searchMyDocs) {
      items = items.filter(
        (item) =>
          item.name &&
          item.name.toLowerCase().includes(searchMyDocs.toLowerCase())
      )
    }

    return items
  }

  const filteredItems = getFilteredItems()

  return (
    <div>
      <CardHeader className='row' style={{justifyContent: "space-between"}}>
        <div
          className='col-lg-6'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {/* Breadcrumb navigation */}
          <div className='mt-2 d-flex justify-content-between'>
            <div className='d-flex align-items-center'>
              <div className='breadcrumb-wrapper'>
                <span style={{ marginRight: '5px' }}>
                  <a //eslint-disable-line
                    title={
                      language.my_library
                        ? language.my_library.back_to_library
                        : 'My Documents'
                    }
                    onClick={() => {
                      setCurrentFolderId(null)
                      setFolderPath([])
                    }}
                    className='root-link text-dark'
                  >
                    <FontAwesomeIcon icon={faHardDrive} />
                  </a>
                  <a //eslint-disable-line
                    title={
                      language.my_library
                        ? language.my_library.back_to_library
                        : 'My Documents'
                    }
                    onClick={() => {
                      setCurrentFolderId(null)
                      setFolderPath([])
                    }}
                    className='back-library-label h4 text-dark'
                  >
                    {language.my_library
                      ? language.my_library.my_drive
                      : 'My Documents'}
                  </a>
                </span>
                {folderPath && folderPath.length
                  ? folderPath.map((folder, index) => (
                      <span
                        key={folder.id}
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle',
                        }}
                      >
                        <span className='divider'> / </span>
                        {index === folderPath.length - 1 ? (
                          <span className='divider-label'>{folder.name}</span>
                        ) : (
                          <span
                            onClick={() => {
                              const newPath = folderPath.slice(0, index + 1)
                              setFolderPath(newPath)
                              setCurrentFolderId(folder.id)
                            }}
                            title={folder.name}
                            className='bc-link'
                          >
                            {folder.name}
                          </span>
                        )}
                      </span>
                    ))
                  : null}
              </div>
            </div>
          </div>
        </div>
        <div >
          <div className='file-folder-search'
            style={{display: "flex", gap: "10px"}}
          >
            <div
              className='add-file-button'
              style={{ display: 'inline-block' }}
            >
              <Link
                to={{
                  pathname: '/library/add-folder',
                  state: { from: 'drive', folderId: currentFolderId },
                }}
                className='mr-2'
                style={{ height: '29px', color: '#172b4d' }}
              >
                <Button
                  color='white'
                  className='border-none px-3 py-2'
                  size='sm'
                  type='button'
                >
                  <FontAwesomeIcon icon={faFolderPlus} className='mr-2' />
                  Add Folder
                </Button>
              </Link>
            </div>
            <div
              className='add-file-button'
              style={{ display: 'inline-block' }}
            >
              <Link
                to={{
                  pathname: '/library/upload-homework',
                  state: { folderId: currentFolderId },
                }}
                className='mr-2'
                style={{ height: '29px', color: '#172b4d' }}
              >
                <Button
                  color='white'
                  className='border-none px-3 py-2'
                  size='sm'
                  type='button'
                >
                  <FontAwesomeIcon icon={faPlus} className='mr-2' />
                  {language.my_library
                    ? language.my_library.add_file
                    : null}{' '}
                </Button>
              </Link>
            </div>
            <div
              className='reorder-courses-wrapper'
              style={{ marginLeft: '10px', width: '230px' }}
            >
              <Search
                placeholder={language.general ? language.general.search : null}
                value={searchMyDocs}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
      </CardHeader>

      <div className='files-folders'>
        {filteredItems && filteredItems.length !== 0 ? (
          filteredItems.map((item) => (
            <div
              key={item.id}
            >
              {props.gridView ? (
                <Card className='book-item content-box'>
                  <button
                    onClick={() => dispatch(deleteMyDocument(item.id))}
                    className='btn btn-danger btn-sm course-edit-btn'
                  >
                    <FontAwesomeIcon icon={faTrash} />
                    <span>
                      {language.general ? language.general.delete : null}
                    </span>
                  </button>

                  {/* Check if item is a folder */}
                  {item.type === 'folder' ? (
                    <div
                      onClick={() => handleFolderClick(item)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div
                        className='book-image-wrapper'
                        style={{
                          backgroundImage: item.thumb
                            ? `url(${item.thumb})`
                            : undefined,
                          backgroundSize: 'cover',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: item.thumb ? undefined : '#f8f9fa',
                          minHeight: '150px',
                        }}
                      >
                        {!item.thumb && (
                          <FontAwesomeIcon
                            icon={faFolder}
                            size='3x'
                            style={{ color: '#007bff' }}
                          />
                        )}
                      </div>
                      <CardFooter className='py-2 text-center'>
                        <h5 className='mt-2' title={item.name}>
                          {item.name}
                        </h5>
                      </CardFooter>
                    </div>
                  ) : (
                    // File handling (existing code)
                    <>
                      {item.path && item.path.includes('.pdf') ? (
                        <Link to={`${item.path}`}>
                          <div
                            className={`book-image-wrapper${
                              !item.thumb ? ' no-thumb-files' : ''
                            }`}
                            style={{
                              backgroundImage: `url(${
                                item.thumb || item.path
                              })`,
                              backgroundSize: 'cover',
                              cursor: 'pointer',
                              minHeight: '150px',
                            }}
                          >
                            {!item.thumb && (
                              <div>
                                <FontAwesomeIcon icon={faFile} />
                              </div>
                            )}
                          </div>
                        </Link>
                      ) : (
                        //eslint-disable-next-line
                        <a
                          href={
                            item.form_submission_data ? undefined : item.path
                          }
                          target={
                            item.form_submission_data ? undefined : '_blank'
                          }
                          onClick={(e) => {
                            if (item.form_submission_data) {
                              e.preventDefault()
                              handleSubmissionClick(item)
                            }
                          }}
                        >
                          <div
                            className={`book-image-wrapper${
                              !item.thumb ? ' no-thumb-files' : ''
                            }`}
                            style={{
                              backgroundImage: `url(${
                                item.thumb || item.path
                              })`,
                              backgroundSize: 'cover',
                              cursor: 'pointer',
                              minHeight: '150px',
                            }}
                          >
                            {!item.thumb && (
                              <div>
                                <FontAwesomeIcon icon={faFile} />
                              </div>
                            )}
                          </div>
                        </a>
                      )}

                      <a //eslint-disable-line
                        href={item.path}
                        target='_blank'
                        className='book-footer'
                      >
                        <CardFooter className='py-2 text-center'>
                          <h5 className='mt-2' title={item.name}>
                            {item.name}
                          </h5>
                        </CardFooter>
                      </a>
                    </>
                  )}
                </Card>
              ) : (
                <Card className='shadow'>
                  <CardBody className='pl-0 py-0'>
                    <Row className='align-items-center '>
                      <Col className='col-sm-4 col-md-2 p-0 border-right'>
                        {/* Check if item is a folder */}
                        {item.type === 'folder' ? (
                          <div
                            onClick={() => handleFolderClick(item)}
                            style={{ cursor: 'pointer' }}
                            className='book-image-wrapper-toggled'
                          >
                            <div
                              style={{
                                backgroundImage: item.thumb
                                  ? `url(${item.thumb})`
                                  : undefined,
                                backgroundSize: 'cover',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: item.thumb
                                  ? undefined
                                  : '#f8f9fa',
                                minHeight: '80px',
                              }}
                            >
                              {!item.thumb && (
                                <FontAwesomeIcon
                                  icon={faFolder}
                                  size='2x'
                                  style={{ color: '#007bff' }}
                                />
                              )}
                            </div>
                          </div>
                        ) : (
                          // File handling (existing code)
                          <>
                            {item.path && item.path.includes('.pdf') ? (
                              <Link to={`${item.path}`}>
                                <div
                                  className={`book-image-wrapper-toggled ${
                                    !item.thumb ? ' no-thumb-files' : ''
                                  }`}
                                  style={{
                                    backgroundImage: `url(${
                                      item.thumb || item.path
                                    })`,
                                    backgroundSize: 'cover',
                                    cursor: 'pointer',
                                    minHeight: '80px',
                                  }}
                                >
                                  {!item.thumb && (
                                    <div>
                                      <FontAwesomeIcon icon={faFile} />
                                    </div>
                                  )}
                                </div>
                              </Link>
                            ) : (
                              //eslint-disable-next-line
                              <a
                                href={
                                  item.form_submission_data
                                    ? undefined
                                    : item.path
                                }
                                target={
                                  item.form_submission_data
                                    ? undefined
                                    : '_blank'
                                }
                                onClick={(e) => {
                                  if (item.form_submission_data) {
                                    e.preventDefault()
                                    handleSubmissionClick(item)
                                  }
                                }}
                              >
                                <div
                                  className={`book-image-wrapper-toggled ${
                                    !item.thumb ? ' no-thumb-files' : ''
                                  }`}
                                  style={{
                                    backgroundImage: `url(${
                                      item.thumb || item.path
                                    })`,
                                    backgroundSize: 'cover',
                                    cursor: 'pointer',
                                    minHeight: '80px',
                                  }}
                                >
                                  {!item.thumb && (
                                    <div>
                                      <FontAwesomeIcon icon={faFile} />
                                    </div>
                                  )}
                                </div>
                              </a>
                            )}
                          </>
                        )}
                      </Col>
                      <div className='ml-2 mt-3 col align-self-start'>
                        {item.type === 'folder' ? (
                          <div
                            onClick={() => handleFolderClick(item)}
                            style={{ cursor: 'pointer' }}
                          >
                            <h4 className='' title={item.name}>
                              <FontAwesomeIcon
                                icon={faFolder}
                                className='mr-2'
                              />
                              {item.name}
                            </h4>
                          </div>
                        ) : (
                          <a //eslint-disable-line
                            href={
                              item.form_submission_data ? undefined : item.path
                            }
                            target={
                              item.form_submission_data ? undefined : '_blank'
                            }
                            className='book-footer'
                            onClick={(e) => {
                              if (item.form_submission_data) {
                                e.preventDefault()
                                handleSubmissionClick(item)
                              }
                            }}
                          >
                            <h4 className='' title={item.name}>
                              {item.name}
                            </h4>
                          </a>
                        )}
                      </div>

                      <Col className='col-auto'>
                        <Button
                          className='btn-icon-only ml-2 edit-item-button'
                          color='danger'
                          onClick={() => dispatch(deleteMyDocument(item.id))}
                          type='button'
                          outline
                          size='sm'
                        >
                          <span className='btn-inner--icon'>
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </span>
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}
            </div>
          ))
        ) : (
          <div className='col-lg-12'>
            <div className='no-library-items'>
              <p className='h4 my-6'>
                {language.my_library ? language.my_library.no_items : null}
              </p>
            </div>
          </div>
        )}
      </div>

      {showViewSubmissionModal && selectedSubmissionId && (
        <ViewSubmissionModal
          submissionId={selectedSubmissionId}
          showViewSubmissionModal={showViewSubmissionModal}
          setShowViewSubmissionModal={setShowViewSubmissionModal}
          userId={access === 1 ? selectedUserId : null}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
      )}
    </div>
  )
}

export default MyDocuments
